import builder from '@rsql/builder';

export const VFL_COMPARATORS = {
  isSet: '=isset=',
  equals: '=equals=',
  contains: '=contains=',
  isNotSet: '=isnotset=',
  greater: '=greater=',
  lesser: '=lesser=',
  between: '=between=',
  greaterEqual: '=greaterequal=',
  lesserEqual: '=lesserequal=',
  in: '=in=',
  isOfType: '=isoftype=',
  isSetTo: '=issetto=',
};
export const VFL_COMPARATORS_FILTER_COMPARATOR_LOOKUP = {
  [VFL_COMPARATORS.isSet]: 'isSet',
  [VFL_COMPARATORS.equals]: 'equals',
  [VFL_COMPARATORS.contains]: 'contains',
  [VFL_COMPARATORS.isNotSet]: 'isNotSet',
  [VFL_COMPARATORS.greater]: 'greater',
  [VFL_COMPARATORS.lesser]: 'lesser',
  [VFL_COMPARATORS.between]: 'between',
  [VFL_COMPARATORS.greaterEqual]: 'greaterEqual',
  [VFL_COMPARATORS.lesserEqual]: 'lesserEqual',
  [VFL_COMPARATORS.in]: 'in',
  [VFL_COMPARATORS.isOfType]: 'isOfType',
  [VFL_COMPARATORS.isSetTo]: 'isSetTo',
};

export default {
  ...builder,
  isSet(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.isSet, values);
  },
  equals(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.equals, values);
  },
  contains(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.contains, values);
  },
  isNotSet(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.isNotSet, values);
  },
  greater(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.greater, values);
  },
  lesser(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.lesser, values);
  },
  between(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.between, values);
  },
  greaterEqual(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.greaterEqual, values);
  },
  lesserEqual(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.lesserEqual, values);
  },
  in(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.in, values);
  },
  isSetTo(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.isSetTo, values);
  },
  isOfType(selector, values) {
    return builder.comparison(selector, VFL_COMPARATORS.isOfType, values);
  },
};
